
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Popper from '../../../element/ui/core/popper';
import * as  lc_color_picker from './lc_color_picker'

import { useStore } from '../../../hooks';
import { SET_LATEST_COLOR } from '../../../actions';
import { StyledColorPicker, StyledPickerTrigger } from './ColorInput.styled';

const pinnedColorsKey = 'respark_pinnedColors';

const ColorInput = forwardRef(function ColorInput(
  {
    position = 'top',
    onChange,
    color,
    triggerOpensPicker = true,
    disabled = false,
  },
  ref,
) {
  const {
    selectionsIds = [],
    config: { annotationsCommon = {} },
    dispatch,
    latestColor,
  } = useStore();
  const triggerRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState();
  const [currentColor, setCurrentColor] = useState(() => color || latestColor || annotationsCommon.fill);
  const [pinnedColors, setPinnedColors] = useState(window?.localStorage ? JSON.parse(localStorage.getItem(pinnedColorsKey) || '[]') : [],);

  const changePinnedColors = (newPinnedColors) => {
    if (!window?.localStorage) {
      return;
    }
    const localStoragePinnedColors = window.localStorage.getItem(pinnedColorsKey);
    if (JSON.stringify(newPinnedColors) !== localStoragePinnedColors) {
      const maxOfSavedColors = 9;
      const pinnedColorsToSave = newPinnedColors.slice(-maxOfSavedColors);
      window.localStorage.setItem(pinnedColorsKey, JSON.stringify(pinnedColorsToSave),);
      setPinnedColors(pinnedColorsToSave);
    }
  };

  const changeColor = (_newColorHex, rgba, newPinnedColors) => {
    // rgba = 'radial-gradient(ellipse, rgba(238,27,27,0.4) 0%, #000000 100%)';
    setCurrentColor(rgba);
    onChange(rgba);
    newPinnedColors && changePinnedColors(newPinnedColors);

    if (latestColor !== rgba) {
      dispatch({
        type: SET_LATEST_COLOR,
        payload: {
          latestColor: rgba,
        },
      });
    }
  };

  const openPicker = useCallback(
    (anchor) => {
      if (disabled) {
        return;
      }
      setAnchorEl(anchor || triggerRef.current);
    },
    [disabled],
  );

  const closePicker = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const togglePicker = useCallback(
    (e) => {
      e?.stopPropagation?.();
      if (disabled) {
        return;
      }
      if (anchorEl) {
        closePicker();
        return;
      }
      openPicker(e?.currentTarget);
    },
    [anchorEl, closePicker, disabled, openPicker],
  );

  useImperativeHandle(
    ref,
    () => ({
      openPicker,
      closePicker,
      togglePicker,
    }),
    [closePicker, openPicker, togglePicker],
  );

  useEffect(() => {
    const colorToSet =
      (selectionsIds.length === 0 && latestColor) ||
      color ||
      annotationsCommon.fill;
    setCurrentColor(colorToSet);
  }, [annotationsCommon.fill, color, latestColor, selectionsIds.length]);

  // useEffect(() => {
  //   window.lc_color_picker('input[name=full]', {
  //     transparency: true,
  //     open_on_focus: true,
  //     wrap_width: '100%',
  //     preview_style: {
  //       input_padding: 45,
  //       side: 'left',
  //       width: 40,
  //     },
  //     fallback_colors: ['#ff0', 'linear-gradient(90deg, rgba(255, 255, 255, .4), #000)'],

  //     on_change: function (new_value, target_field) {
  //       console.log(new_value, target_field);
  //       setCurrentColor(new_value);
  //       dispatch({
  //         type: SET_LATEST_COLOR,
  //         payload: {
  //           latestColor: new_value,
  //         },
  //       });
  //     },
  //   });
  // }, [])

  const oneywPickerClick = () => {
    const eyeDropper = new window.EyeDropper();
    eyeDropper.open().then((result) => {
      changeColor('', result.sRGBHex, null);
    }).catch(() => {});
  }

  return (
    <>
      <script src="./lc_color_picker"></script>
      <StyledPickerTrigger
        ref={triggerRef}
        className="respark_color-picker-triggerer"
        onClick={triggerOpensPicker ? togglePicker : undefined}
        $color={currentColor}
        onChange={onChange}
        aria-hidden={triggerOpensPicker ? undefined : true}
      />
      {anchorEl && <Popper
        className="respark_color-picker"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        position={position}
        onClick={closePicker}
        overlay
        zIndex={11111}
      >
        <StyledColorPicker
          onChange={changeColor}
          defaultColor={currentColor}
          pinnedColors={pinnedColors}
          showTransparentColor
        />
        {/* {window.EyeDropper && <button id="start-button" onClick={oneywPickerClick}>Open the eyedropper</button>} */}
      </Popper>}
      {/* <input type="text" name="full" value="linear-gradient(90deg, rgba(255, 255, 255, .4), #000)" /> */}
    </>
  );
});


ColorInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  position: PropTypes.string,
  color: PropTypes.string,
  triggerOpensPicker: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default ColorInput;
